export const related = [
  '/build-planner',
  '/abilities/ground-slam-vs-push',
  '/abilities',
];
export const quickAnswer =
  'Our editorial default is Shield for a defensive, Falter-friendly approach. Pick Barrage for projectiles or Volatile Anomaly for an explosive summon.';
export const sourceIds = ['gamesradar-abilities', 'ps-ngplus'];
export const table = {
  headers: ['Ability', 'Fit', 'Trade-off'],
  rows: [
    [
      'Barrage',
      'Direct projectile play',
      'Choose if you want a ranged action in your rotation.',
    ],
    [
      'Volatile Anomaly',
      'Explosive summon play',
      'Choose if you enjoy managing an ally.',
    ],
    [
      'Shield',
      'Defensive close-in play',
      'Choose if safer approaches matter more to you.',
    ],
  ],
};

## Quick Comparison

These three alternatives follow the Artist Resonant. Think about the action you want to use repeatedly, rather than a theoretical tier list.

## Barrage

A direct projectile option is an intuitive fit when you prefer pointing at the target and acting yourself. Consider whether another ranged action already fills that role in your plan.

## Volatile Anomaly

An explosive summon fits a player who enjoys indirect pressure. If managing another entity interrupts your preferred rhythm, one of the direct-action options may feel more comfortable.

## Shield

Our defensive recommendation is Shield. That recommendation reflects a preference for protection and Falter-friendly play, rather than a claim that every encounter favors it.

## Which Should You Pick?

For a first plan, choose the role you currently lack: defense, projectiles or a summon. Revisit the decision after you know which actions you actually use.

## Can You Change the Choice Later?

Respec is available at the mural in The Gap with a Reset Item. The planner's reset only clears this website's selections; it does not change your game.
